import React, { useEffect, useState } from 'react';
import { Lock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import './OvertimeTaxFrozen.css';
import { overtimeAPI } from '../services/api';
import { reportLoadError } from '../utils/notify';

// Overtime tax is frozen until the client decides. Payroll applies the
// database function calculate_overtime_tax(): this shows its brackets and the
// tax it returns for a few amounts. Nothing here can be edited; the old
// editors changed a table payroll never read.
const OvertimeTaxFrozen = () => {
  const { t, locale } = useLanguage();
  const [applied, setApplied] = useState(null);

  useEffect(() => {
    overtimeAPI.getAppliedTax()
      .then((response) => setApplied(response.data))
      .catch((error) => reportLoadError(error, t('Error loading the overtime tax')));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const money = (n) => Number(n).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <div className="otf">
      <p className="otf__banner" role="note">
        <Lock aria-hidden="true" /> {t('Frozen: pending the client\'s decision. Read-only.')}
      </p>
      <p>{t('Payroll applies these brackets to overtime pay (database function calculate_overtime_tax):')}</p>
      {!applied ? (
        <p>{t('Loading...')}</p>
      ) : (
        <>
          <div className="otf__table-wrap">
            <table className="data-table">
              <thead>
                <tr><th className="num">{t('From (SRD)')}</th><th className="num">{t('To (SRD)')}</th><th className="num">{t('Rate')}</th></tr>
              </thead>
              <tbody>
                {applied.brackets.map((b) => (
                  <tr key={b.from}>
                    <td className="num">{money(b.from)}</td>
                    <td className="num">{b.to === null ? t('and above') : money(b.to)}</td>
                    <td className="num">{b.rate}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <h4 className="otf__subtitle">{t('What the function returns')}</h4>
          <div className="otf__table-wrap">
            <table className="data-table">
              <thead>
                <tr><th className="num">{t('Overtime gross (SRD)')}</th><th className="num">{t('Overtime tax (SRD)')}</th></tr>
              </thead>
              <tbody>
                {applied.examples.map((e) => (
                  <tr key={e.gross}><td className="num">{money(e.gross)}</td><td className="num">{money(e.tax)}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default OvertimeTaxFrozen;
